export const LS_ACCESS_TOKEN_KEY = 'gitment-comments-token'
export const LS_USER_KEY = 'gitment-user-info'

export const NOT_INITIALIZED_ERROR = new Error('Comments Not Initialized')



// WEBPACK FOOTER //
// ./constants.js